import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import loadable from '@loadable/component'
import { Loader } from '../../../../common/components';


const ListDBFieldTypePage = loadable(() => import('./ListDBFieldTypePage'), {
    fallback: <Loader/>,
});
const AddDBFieldTypePage = loadable(() => import('./AddDBFieldTypePage'), {
    fallback: <Loader/>,
});
const EditDBFieldTypePage = loadable(() => import('./EditDBFieldTypePage'), {
    fallback: <Loader/>,
});
const DBFieldTypeRoute = ({ t, alert }) => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListDBFieldTypePage t={t} alert={alert} />} />
      <Route exact path="/add" element={<AddDBFieldTypePage t={t} alert={alert} />} />
      <Route exact path="/edit/:id" element={<EditDBFieldTypePage t={t} alert={alert} />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};
DBFieldTypeRoute.propTypes = {
  t: PropTypes.func
};
export default DBFieldTypeRoute;
